import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/format";

const AuthContext = createContext(null);
const STORAGE_KEY = "bp_admin_token";

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(STORAGE_KEY));
  const [me, setMe] = useState(null);
  const [checking, setChecking] = useState(!!token);

  useEffect(() => {
    if (!token) { setMe(null); setChecking(false); return; }
    axios.get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setMe(r.data))
      .catch(() => { localStorage.removeItem(STORAGE_KEY); setToken(null); setMe(null); })
      .finally(() => setChecking(false));
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(STORAGE_KEY, data.token);
    setToken(data.token);
    return data;
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setToken(null);
    setMe(null);
  };

  const authHeader = () => (token ? { Authorization: `Bearer ${token}` } : {});

  return (
    <AuthContext.Provider value={{ token, me, checking, login, logout, authHeader }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
